import React from 'react';
import PropTypes from 'prop-types';
import { useIsMobile } from 'utils/hooks';
import { Dialog, H1, P, Div } from 'components/Ui';
import { SomethingWentWrongImage } from 'images';
import styles from './styles.scss';

const NoUpcomingDeliveriesDialog = ({ open, setStatus, dateDelivery }) => {
  const isMobile = useIsMobile();
  const title = 'We’re sorry!';
  const message = 'We’re not in the area until your next delivery.';
  const label = 'Your next delivery will be:';
  return (
    <Dialog
      size="small"
      fullScreen={isMobile}
      isAutoClose={false}
      isCloseIcon
      open={open}
      onClose={setStatus}
      aria-labelledby="dialog-title"
    >
      <div className={styles.container}>
        <div
          className={!isMobile ? styles.subContainer : styles.mobileContainer}
        >
          <div className={styles.imageContainer}>
            <img src={SomethingWentWrongImage} alt=""></img>
          </div>
          <H1 className={styles.headerContainer} id="dialog-title">
            {title}
          </H1>
          <div className={styles.textContainer}>
            <P>{message}</P>
            <Div className={styles.label}>{label}</Div>
            <p className={styles.deliveryDate}>{dateDelivery}</p>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

NoUpcomingDeliveriesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default NoUpcomingDeliveriesDialog;
